






























import { Component, Prop, Vue } from 'vue-property-decorator';

import { BrandedPolicyDetails } from '@/common/Users';

import Brand from '@/services/Brand';

@Component({
	name: 'PoliciesTable',
})
export default class PoliciesTable extends Vue {
	@Prop() private policies: BrandedPolicyDetails[];

	private readonly Brand = Brand;

	get showActionsColumn(): boolean {
		return !!(this.$slots.actionsColumn ?? this.$scopedSlots.actionsColumn);
	}

	get sortedPolicies(): BrandedPolicyDetails[] {
		return this.policies
			.slice()
			.sort(
				(a: BrandedPolicyDetails, b: BrandedPolicyDetails): number =>
					Brand.getProperBrand(a.brand).localeCompare(Brand.getProperBrand(b.brand)) ||
					a.policy_number.localeCompare(b.policy_number),
			);
	}
}
